import { getSelectioAxios, setUser } from '@/main';

export default class ExportService {

  excelBasic(payload) {
    return getSelectioAxios()
      .post('/legacy-export/api/v1/excel/generic', payload)
      .then(res => res.data)
      .catch(e => {
        if (e.request.status === 403)
          setUser(null);
        throw e;
      });
  }

  csv(payload) {
    return getSelectioAxios()
      .post('/legacy-export/api/v1/csv/generic', payload)
      .then(res => res.data)
      .catch(e => {
        if (e.request.status === 403)
          setUser(null);
        throw e;
      });
  }
}
